import icon from '../images/unavalibleMobileImage.png';
import { Colors } from '../themes/colors';
import { Button } from '@tempmee/react';

export const UnavailableMobile = () => {
  const submitButtonPressed = () => {
    window.open('https://apps.apple.com/us/app/tempmee/id1437086894', '_blank');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        src={icon}
        alt="Unavailable Mobile"
        style={{ marginTop: 50, marginBottom: 30, maxWidth: 300 }}
      />
      <span
        style={{
          fontFamily: 'Nunito',
          fontWeight: 'bold',
          fontSize: 18,
          textAlign: 'center',
          width: '80%',
          marginBottom: 40,
          color: Colors.neutral_600,
          display: 'block',
        }}
      >
        To continue with GoTu’s Dental Portal, come back on desktop or download the app.
      </span>
      <Button size="lg" onClick={submitButtonPressed}>
        Download GoTu
      </Button>
    </div>
  );
};
